module.exports = __webpack_public_path__ + "img/logo.5ca8d6ed.png";